// Copyright © 2021 Move Closer
import { RouterDriver } from '@movecloser/front-core';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const ROUTER_DRIVER = RouterDriver.VueRouter;
